import React from 'react';
import PropTypes from 'prop-types';
import SignatureTile from '../../common/signatures/SignatureTile';

export default function FormSignature({
  employeeSignature,
  signatureMetadata,
  signatureConfig,
}) {
  if (!employeeSignature) return null;

  const fullSignature = {
    id: 'form-signature',
    sig: employeeSignature,
    timestamp: signatureMetadata?.timestamp,
    timezone: signatureMetadata?.timezone,
    latitude: signatureMetadata?.latitude,
    longitude: signatureMetadata?.longitude,
  };

  return (
    <div className="form-signature-container">
      <div className="form-signature-header">
        Signature
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <SignatureTile
          signature={fullSignature}
          isDisplay
          showDate={signatureConfig?.showDate}
          showSignatureTime={signatureConfig?.showTime}
          collectGeolocation={signatureConfig?.collectGeolocation}
          hideName
        />
      </div>
    </div>
  );
}

/* eslint-disable react/forbid-prop-types */
FormSignature.propTypes = {
  employeeSignature: PropTypes.object,
  signatureMetadata: PropTypes.object,
  signatureConfig: PropTypes.object,
};

FormSignature.defaultProps = {
  employeeSignature: null,
  signatureMetadata: null,
  signatureConfig: null,
};
